import type { CSSProperties } from 'react';
import { Link } from 'react-router-dom';

interface Props {
  /** Optional concept slug. Omit to link to the top of /help. */
  slug?: string;
  /** Accessible label. Defaults to "What is this?". */
  label?: string;
}

const iconStyle: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 24,
  height: 24,
  borderRadius: 'var(--loop-radius-sm)',
  border: '1px solid var(--loop-neutral-300)',
  background: 'var(--loop-neutral-0)',
  color: 'var(--loop-neutral-700)',
  textDecoration: 'none',
  fontSize: '0.875rem',
  fontWeight: 528,
  lineHeight: 1,
  cursor: 'pointer',
};

export function ConceptHelpIcon({ slug, label = 'What is this?' }: Props) {
  const to = slug ? `/help#${slug}` : '/help';
  return (
    <Link to={to} style={iconStyle} aria-label={label} title={label}>
      ?
    </Link>
  );
}
